module.exports = __webpack_public_path__ + "static/media/trunk_l.67856623.svg";